import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import { uploadUserImage } from "../../../../api/auth";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { countries } from "./countries";

export default function VerticalForm({
  openModal,
  setOpenModal,
  fields,
  formData = {},
  handleFormSubmit = () => {},
  title = "",
}) {
  // Build defaultValues from fields
  let defaultValues = {};

  fields?.forEach((field) => {
    if (field.type === "radio" || field.type === "select") {
      defaultValues[field.name] = field.options[0]?.value;
    } else if (field.type === "checkbox") {
      defaultValues[field.name] = false;
    } else {
      defaultValues[field.name] = "";
    }
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm({ defaultValues });

  // For mobile number helper
  const splitMobile = (mobile, countries) => {
    if (!mobile || !mobile.startsWith("+"))
      return { mobile_country: "", mobile: mobile || "" };

    // Sort countries by dial_code length descending for longest match first
    const sortedCountries = [...countries].sort(
      (a, b) => b.dial_code.length - a.dial_code.length
    );

    for (const country of sortedCountries) {
      if (mobile.startsWith(country.dial_code)) {
        return {
          mobile_country: country.dial_code,
          mobile: mobile.slice(country.dial_code.length),
        };
      }
    }

    // No match found
    return { mobile_country: "", mobile };
  };

  useEffect(() => {
    if (openModal && formData) {
      let splitData = { ...formData };
      if (formData.mobile) {
        const { mobile_country, mobile } = splitMobile(
          formData.mobile,
          countries
        );
        splitData.mobile_country =
          mobile_country || countries[0]?.dial_code || "+1";
        splitData.mobile = mobile;
      } else {
        splitData.mobile_country = countries[0]?.dial_code || "+1";
      }

      reset(splitData);
    }
  }, [openModal, formData, reset]);

  // useEffect(() => {
  //   if (openModal && formData) {
  //     reset(formData);
  //   }
  // }, [openModal, formData, reset]);

  // const onSubmit = (data) => {

  //   handleFormSubmit(data);
  // };

  const onSubmit = async (data) => {
    console.log("submitinf", data);
    const fullMobile = `${data.mobile_country}${data.mobile}`;
    const submitData = {
      ...data,
      mobile: fullMobile,
    };
    delete submitData.mobile_country; // remove separate country code if not needed
    handleFormSubmit(submitData);
    setSelectedFile(null);
    setOpenModal(false);
  };

  const handleClose = () => {
    reset({});
    setOpenModal(false);
  };

  const renderField = (field) => {
    const { type, name, label, placeholder, options, validation } = field;
    switch (type) {
      case "email":
      case "password":
      case "text":
      case "number":
      case "date":
      case "datetime-local":
        return (
          <div className="mb-3 row" key={name}>
            <label className="col-sm-3 col-form-label">{label}</label>
            <div className="col-sm-9">
              <input
                type={type}
                step={type === "number" ? "any" : undefined}
                className="form-control"
                placeholder={placeholder}
                {...register(name, validation)}
              />
              {errors[name] && (
                <span className="text-danger">{errors[name]?.message}</span>
              )}
            </div>
          </div>
        );

      case "checkbox":
        return (
          <div className="mb-3 row" key={name}>
            <label className="col-sm-3 col-form-label">{label}</label>
            <div className="col-sm-9">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  {...register(name, validation)}
                />
              </div>
              {errors[name] && (
                <span className="text-danger">{errors[name]?.message}</span>
              )}
            </div>
          </div>
        );

      case "radio":
        return (
          <fieldset className="form-group mb-3" key={name}>
            <div className="row">
              <legend className="col-form-label col-sm-3 pt-0">{label}</legend>
              <div className="col-sm-9">
                {options?.map((opt, idx) => (
                  <div className="form-check" key={opt.value}>
                    <input
                      className="form-check-input"
                      type="radio"
                      value={opt.value}
                      {...register(name, validation)}
                      id={`${name}-${idx}`}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`${name}-${idx}`}
                    >
                      {opt.label || opt.value}
                    </label>
                  </div>
                ))}
                {errors[name] && (
                  <span className="text-danger">{errors[name]?.message}</span>
                )}
              </div>
            </div>
          </fieldset>
        );

      case "file":
        return (
          <div className="mb-3 row">
            <legend className="col-form-label col-sm-3 pt-0">{label}</legend>
            <div className="col-sm-9">
              <Controller
                name={name}
                control={control}
                rules={validation}
                render={({ field: { onChange, ref }, fieldState }) => (
                  <>
                    <input
                      id={name}
                      type="file"
                      accept="image/*"
                      ref={ref}
                      onChange={async (e) => {
                        const file = e.target.files[0];
                        if (file) {
                          setSelectedFile(file);
                          try {
                            const formData = new FormData();
                            formData.append("file", file);
                            const res = await uploadUserImage(formData);
                            console.log("onChange", res.filename);
                            onChange(res.filename);
                          } catch (err) {
                            console.error("Image upload failed", err);
                          }
                        } else {
                          onChange("");
                        }
                      }}
                      className={`form-control ${
                        fieldState.invalid ? "is-invalid" : ""
                      }`}
                    />
                    {fieldState.error && (
                      <div className="invalid-feedback">
                        {fieldState.error.message}
                      </div>
                    )}
                    {/* Preview */}
                    {selectedFile ? (
                      <div className="mt-2">
                        <img
                          src={URL.createObjectURL(selectedFile)}
                          alt="Preview"
                          style={{ height: 50 }}
                        />
                      </div>
                    ) : null}
                  </>
                )}
              />
            </div>
          </div>
        );

      case "ckeditor":
        return (
          <div className="mb-3 row" key={name}>
            <label className="col-sm-3 col-form-label">{label}</label>
            <div className="col-sm-9">
              <Controller
                name={name}
                control={control}
                rules={validation}
                render={({ field: { onChange, value } }) => (
                  <>
                    <CKEditor
                      editor={ClassicEditor}
                      data={value || ""}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        onChange(data);
                      }}
                    />
                    {errors[name] && (
                      <span className="text-danger">
                        {errors[name]?.message}
                      </span>
                    )}
                  </>
                )}
              />
            </div>
          </div>
        );
      case "tel":
        return (
          <div className="mb-3 row" key={name}>
            <label className="col-sm-3 col-form-label">{label}</label>
            <div className="col-sm-9">
              <div className="input-group">
                <select
                  className="form-select"
                  style={{ maxWidth: "120px" }}
                  {...register(`${name}_country`, {
                    required: "Country code is required",
                  })}
                >
                  <option value="" disabled hidden>
                    Country
                  </option>

                  {countries.map((country) => (
                    <option key={country.code} value={country.dial_code}>
                      {country.emoji} {country.dial_code}
                    </option>
                  ))}
                </select>

                <input
                  type="tel"
                  className="form-control"
                  placeholder={placeholder || "Enter mobile number"}
                  {...register(name, {
                    required: "Mobile number is required",
                    pattern: {
                      value: /^\d{7,15}$/, // More flexible pattern for international numbers
                      message: "Invalid mobile number format",
                    },
                  })}
                />
              </div>

              {errors[`${name}_country`] && (
                <span className="text-danger d-block">
                  {errors[`${name}_country`]?.message}
                </span>
              )}
              {errors[name] && (
                <span className="text-danger d-block">
                  {errors[name]?.message}
                </span>
              )}
            </div>
          </div>
        );
      case "select":
        return (
          <div className="mb-3 row" key={name}>
            <label className="col-sm-3 col-form-label">{label}</label>
            <div className="col-sm-9">
              <Controller
                name={name}
                control={control}
                rules={validation}
                render={({ field: { onChange, value, ref } }) => (
                  <Select
                    inputRef={ref}
                    value={options.find((opt) => opt.value === value)}
                    defaultValue={options[0]}
                    onChange={(val) => onChange(val.value)}
                    options={options}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        borderColor: state.isFocused
                          ? "#7e5bef"
                          : "rgba(238, 238, 238, 0.9333333333)",
                        boxShadow: "none",
                        borderRadius: "8px",
                        padding: "2px",
                        fontSize: "14px",
                        height: "40px",
                        "&:hover": {
                          borderColor: "none", // Match focus color on hover
                        },
                      }),
                      placeholder: (base) => ({
                        ...base,
                        color: "#6c757d",
                      }),
                      singleValue: (base) => ({
                        ...base,
                        color: "#495057",
                      }),
                      dropdownIndicator: (base) => ({
                        ...base,
                        color: "#7e5bef",
                      }),
                    }}
                  />
                )}
              />
              {errors[name] && (
                <span className="text-danger">{errors[name]?.message}</span>
              )}
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <Modal className="fade bd-example-modal-lg" show={openModal} size="lg">
      <Modal.Header>
        <Modal.Title>{title} Form</Modal.Title>
        <Button variant="" className="btn-close" onClick={handleClose} />
      </Modal.Header>
      <Modal.Body>
        <form id="react-hook-form" onSubmit={handleSubmit(onSubmit)}>
          {fields?.map(renderField)}
        </form>
      </Modal.Body>
      <Modal.Footer className="border-top">
        <Button variant="danger light" onClick={handleClose}>
          Close
        </Button>
        <Button
          variant="primary"
          type="submit"
          form="react-hook-form"
          className="ms-2"
        >
          Save changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
